import { IFetchSessionTranscriptActionParams } from '../../page/session-transcript/transcripts.types';
import { ISession } from '../../resource/session/session.types';
import { IApiRequestConfig } from '../api.types';

export const fetchSessionTranscriptApi = (
  sessionId: ISession['id'],
  params?: IFetchSessionTranscriptActionParams,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'fetchSessionTranscript',
  uri: 'json',
  action: `sessions/${sessionId}/transcript`,
  method: 'get',
  params: params,
  v2: true,
});
